export default __webpack_public_path__ + "static/media/csv.b334185f.svg";